export default __webpack_public_path__ + "static/media/luria_petrucci.3d9326cb.png";